import React from 'react';
import styles from './ReasonCode.module.scss';
import { Badge, Stack, Typography } from "@mui/material";
import AirIcon from "@mui/icons-material/Air";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import ErrorIcon from "@mui/icons-material/Error";
import PersonAddRoundedIcon from '@mui/icons-material/PersonAddRounded';
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import CallSplitRoundedIcon from '@mui/icons-material/CallSplitRounded';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import RestoreRoundedIcon from '@mui/icons-material/RestoreRounded';
import MoveDownRoundedIcon from '@mui/icons-material/MoveDownRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import ArchiveRoundedIcon from '@mui/icons-material/ArchiveRounded';
import FavoriteBorderRoundedIcon from '@mui/icons-material/FavoriteBorderRounded';
import ShuffleRoundedIcon from '@mui/icons-material/ShuffleRounded';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import SignpostSharpIcon from '@mui/icons-material/SignpostSharp';
import BedRoundedIcon from '@mui/icons-material/BedRounded';
import ScaleRoundedIcon from '@mui/icons-material/ScaleRounded';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import MasksRoundedIcon from '@mui/icons-material/MasksRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LooksOneRoundedIcon from '@mui/icons-material/LooksOneRounded';
import LooksTwoRoundedIcon from '@mui/icons-material/LooksTwoRounded';
import RepeatRoundedIcon from '@mui/icons-material/RepeatRounded';
import ReplayIcon from '@mui/icons-material/Replay';
import { OrderReasonEnum, OrderReasonPickUpEnum } from '../../enums';

const iconSx = { fontSize: "1.5rem" };

const PICKUP_CONFIG = {
  'equipment move':     { Icon: ArrowCircleRightRoundedIcon, color: "var(--color-grey)",   label: "Equipment Move" },
  'd&d':               { Icon: FavoriteBorderRoundedIcon,   color: "var(--color-green)",  label: "D&D" },
  'expired':           { Icon: FavoriteRoundedIcon,         color: "var(--color-red)",    label: "Expired" },
  'live discharge':    { Icon: FavoriteRoundedIcon,         color: "var(--color-yellow)", label: "Live Discharge" },
  'not needed':        { Icon: ArchiveRoundedIcon,          color: "var(--color-yellow)", label: "Not Needed" },
  'equipment exchange':{ Icon: ForwardToInboxRoundedIcon,   color: "var(--color-yellow)", label: "Equipment Exchange" },
  'lost attempt 1':    { Icon: HelpRoundedIcon,             color: "var(--color-green)",  label: "Lost Attempt 1", BadgeIcon: LooksOneRoundedIcon, badgeColor: "var(--color-orange)" },
  'lost attempt 2':    { Icon: HelpRoundedIcon,             color: "var(--color-green)",  label: "Lost Attempt 2", BadgeIcon: LooksTwoRoundedIcon, badgeColor: "var(--color-orange)" },
};

const DELIVERY_CONFIG = {
  'respiratory distress':           { Icon: AirIcon,                    iconClassName: styles.backgroundColorBlue,     label: "Respiratory Distress",        BadgeIcon: ErrorIcon,   badgeColor: "var(--color-red)" },
  'add on respiratory/oxygen':      { Icon: AddCircleRoundedIcon,       iconClassName: styles.backgroundColorBlue,     label: "Add On Respiratory/Oxygen" },
  'hi-tech respiratory':            { Icon: BoltRoundedIcon,            color: "var(--color-base)",                    label: "Hi-Tech Respiratory" },
  'o2 equipment repair/replace':    { Icon: SwapVertIcon,               color: "var(--color-base)",                    label: "O2 Equipment Repair/Replace" },
  'service: respiratory equipment': { Icon: ConstructionRoundedIcon,    color: "var(--color-base)",                    label: "Service: Respiratory Equipment" },
  'service: weighing service':      { Icon: ScaleRoundedIcon,           color: "var(--color-grey)",                    label: "Service: Weighing Service" },
  'service: room change':           { Icon: MoveDownRoundedIcon,        color: "var(--color-grey)",                    label: "Service: Room Change" },
  'change of address':              { Icon: EditLocationAltIcon,        color: "var(--color-grey)",                    label: "Change Address" },
  'respite stay':                   { Icon: RestoreRoundedIcon,         color: "var(--color-grey)",                    label: "Respite Stay" },
  'urgent admission':               { Icon: PersonAddRoundedIcon,       color: "var(--color-red)",                     label: "Urgent Admission" },
  'first delivery':                 { Icon: PersonRoundedIcon,          color: "var(--color-red)",                     label: "First Delivery" },
  'patient safety':                 { Icon: HealthAndSafetyRoundedIcon, color: "var(--color-red)",                     label: "Patient Safety" },
  'split order':                    { Icon: CallSplitRoundedIcon,       color: "var(--color-red)",                     label: "Split Order" },
  'add on general':                 { Icon: AddCircleRoundedIcon,       color: "var(--color-yellow)",                  label: "Add On General" },
  'disposable items':               { Icon: MasksRoundedIcon,           color: "var(--color-yellow)",                  label: "Disposable Items" },
  'service: bed equipment':         { Icon: BedRoundedIcon,             color: "var(--color-yellow)",                  label: "Service: Bed Equipment" },
  'service: general equipment':     { Icon: ConstructionRoundedIcon,    iconClassName: styles.constructionRoundedIcon, label: "Service: General Equipment" },
  'billing purposes':               { Icon: PriceCheckIcon,             color: "var(--color-green)",                   label: "Billing Purposes" },
  'internal transfer':              { Icon: SwapHorizontalCircleIcon,   color: "var(--color-green)",                   label: "Internal Transfer" },
  'conversion':                     { Icon: ShuffleRoundedIcon,         color: "var(--color-green)",                   label: "Conversion" },
  'switchout':                      { Icon: SignpostSharpIcon,          color: "var(--color-green)",                   label: "Switchout" },
  'quote':                          { Icon: RequestQuoteRoundedIcon,    color: "var(--color-green)",                   label: "Quote Order" },
  'recurring order':                { Icon: RepeatRoundedIcon,          iconClassName: styles.backgroundColorYellow,   label: "Recurring" },
  're-admit':                       { Icon: PersonRoundedIcon,          color: "var(--color-red)",                     label: "Re-admit", BadgeIcon: ReplayIcon, badgeColor: "var(--color-red)" },
};

const ReasonCodeIcon = ({ Icon, color, iconClassName, BadgeIcon, badgeColor, label }) => {
  const iconEl = (
    <Icon className={iconClassName} sx={{ ...iconSx, ...(color ? { color } : {}) }} />
  );
  return (
    <Stack direction="column" alignItems="center" gap={1}>
      {BadgeIcon ? (
        <Badge badgeContent={<BadgeIcon sx={{ color: badgeColor, fontSize: "1rem" }} />}>
          {iconEl}
        </Badge>
      ) : iconEl}
      <Typography color="text.secondary" fontWeight="medium" textAlign="center" sx={{ maxWidth: "5rem", overflowWrap: 'break-word' }}>
        {label}
      </Typography>
    </Stack>
  );
};

const ReasonCode = (orderReasonCode = "", orderType = "Delivery") => {
  if (orderType === "Pickup" || orderType === "Pick Up") {
    const config = PICKUP_CONFIG[(OrderReasonPickUpEnum[orderReasonCode] ?? "").toLowerCase()];
    return config ? <ReasonCodeIcon {...config} /> : null;
  } else {
    const config = DELIVERY_CONFIG[(OrderReasonEnum[orderReasonCode] ?? "").toLowerCase()];
    return config ? <ReasonCodeIcon {...config} /> : null;
  }
};

export default ReasonCode;
